import type { SxProps, Theme } from '@mui/material';

import { Typography } from '@mui/material';

export interface HelperMessageProps {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
}

export const HelperMessage = ({
  children,
  className,
  sx,
}: HelperMessageProps) => {
  return (
    // `text.secondary`, never a fixed grey: MUI resolves the string token to
    // the palette's CSS var, so this line follows the tenant's theme instead of
    // sitting at #808080 on whatever surface it lands on.
    <Typography
      color="text.secondary"
      className={className}
      variant="body2"
      sx={sx}
    >
      {children}
    </Typography>
  );
};
